import stipulate from 'stipulate';
import urlJoin from 'url-join';
import { baseUrl } from './base';

const createCustomHostname = function (options) {
  if (!options.name) {
    throw new Error('Expected options.name to be set');
  }
  let url = urlJoin(baseUrl, '/pb/custom-hostnames/');
  if (options.apiUrl) {
    url = urlJoin(options.apiUrl, url);
  }
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({'name': options.name}),
  };

  return stipulate(url, fetchOptions);
};

export default createCustomHostname;
